"use client";

import { useAuth } from "@/components/features/auth/hooks/use-auth";
import { useUserOrganizations } from "@/components/features/users/hooks/use-user-orgs";
import { routes } from "@/lib/routes";
import {
  ArrowLeftRight,
  BriefcaseBusiness,
  Cog,
  Home,
  Info,
  LayoutDashboard,
  Plus,
  Search,
  User,
  UserRoundCog,
} from "lucide-react";
import { useMemo } from "react";
import { NavItem } from "../types";

export function useMainNavItems(): NavItem[] {
  const { isAuthenticated } = useAuth();

  return useMemo(
    () => [
      {
        name: "Home",
        href: routes.home,
        icon: Home,
        visible: true,
      },
      {
        name: "Search",
        href: routes.search.root,
        icon: Search,
        visible: true,
      },
      {
        name: "About",
        href: routes.about,
        icon: Info,
        visible: true,
      },

      {
        name: "My Local",
        href: routes.myLocal,
        icon: LayoutDashboard,
        visible: isAuthenticated,
      },
    ],
    [isAuthenticated],
  );
}

export function useAccountNavItems(
  setAccountSwitcherOpen: (open: boolean) => void,
): NavItem[] {
  const { isAuthenticated, activeOrg } = useAuth();
  const orgMemberships = useUserOrganizations();
  const hasOrgs = orgMemberships.orgCount > 0;

  return useMemo(
    () => [
      {
        name: "Profile",
        href: routes.profile,
        icon: User,
        visible: isAuthenticated,
      },
      {
        name: "Settings",
        href: routes.settings,
        icon: Cog,
        visible: false,
      },
      {
        name: "Professional",
        icon: BriefcaseBusiness,
        visible: isAuthenticated,
        children: [
          {
            name: "Admin",
            href: routes.admin.root,
            icon: UserRoundCog,
            visible: Boolean(activeOrg),
          },
          {
            name: "Switch Account",
            onClick: () => {
              setAccountSwitcherOpen(true);
            },
            icon: ArrowLeftRight,
            visible: hasOrgs,
          },
          {
            name: "New Account",
            href: routes.auth.org.create,
            icon: Plus,
            visible: isAuthenticated,
          },
        ],
      },
    ],
    [activeOrg, hasOrgs, isAuthenticated, setAccountSwitcherOpen],
  );
}
